import React, { forwardRef } from 'react';
const AvatarBadge = (StyledAvatarBadge) => forwardRef(({ children, ...props }, ref) => {
    return (<StyledAvatarBadge ref={ref} {...props}>
        {children}
      </StyledAvatarBadge>);
});
export default AvatarBadge;
